import OverdueMaintenanceReferenceList from '@/components/OverdueMaintenanceReference/OverdueMaintenanceReferenceList'

let OverdueMaintenanceReferenceRouter = [{
  path: '/overdue_maintenance_reference',
  name: 'OverdueMaintenanceReferenceList',
  component: OverdueMaintenanceReferenceList,
  meta: {
    title: 'Références en attente de maintenance',
    requiresAuth: true,
    authorizations: ['reference_index', 'desktop_access']
  }
}]

export default OverdueMaintenanceReferenceRouter



// WEBPACK FOOTER //
// ./src/components/OverdueMaintenanceReference/router.js